<mat-expansion-panel class="box-shadow border-radius-0">
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">public</mat-icon>
      <span>Overview</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    @if (screenSize$ | async) {
    @if (connectionStatus$ | async; as connectionStatus) {
    @if (connectionStatus === 'offline') {
    <div class="flex-center text-base">Map not available offline.</div>
    }
    }
    @if (theme$ | async; as theme) {
    <div class="map-container" [style.opacity]="mapIsReady ? '1.0' : '0'" @fadeIn>
      <div id="map" [class.dark-theme]="theme === 'dark'">
        <button class="map-reset-btn" (click)="onResetMap()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
    }
    @if (flightInfo$ | async; as flightInfo) {
    @if (flightInfo.isLoading && !flightInfo.response)
    {
    <div class="flex-center mt-32">
      <mat-spinner color="accent" [diameter]="32"></mat-spinner>
    </div>
    }
    @if (!flightInfo.isLoading && !flightInfo.response) {
    <div class="text-sm flex-center m-16">Station details not available.</div>
    }
    @if (flightInfo.response) {
    <div class="dep-arr-labels">
      <div class="label-2 pb-4">Depart</div>
      <div class="label-2 pb-4">Arrive</div>
    </div>
    <div class="thin-gray-border arpt-info">
      <div class="grid-container">
        <div class="col">
          <div class="col">
            <div class="arpt-container">
              <div class="text-center text-base">{{ flightInfo.response.departure.icao }}/{{
                flightInfo.response.departure.station
                }}</div>
              <div class="text-center text-sm opacity-6">{{ flightInfo.response.departure.name }}</div>
            </div>
            <div class="text-center text-base mt-6">
              <span>{{
                flightInfo.response.departure.depOrArrTimeLocal?.toFormat('HH:mm') }}L </span>
              <span class="opacity-6">({{
                flightInfo.response.departure.depOrArrTimeUtc?.toFormat('HH:mm') }}Z)</span>
            </div>

          </div>

          <div class="details-container">
            <mat-divider class="mr-8 width-100"></mat-divider>
            <div class="details-grid">
              <div class="label-3 pr-1">Elev</div>
              <div class="text-base pl-8">{{ flightInfo.response.departure.elevation }}</div>
              <div class="label-3 pr-1">UTC</div>
              <div class="text-base pl-8">{{ flightInfo.response.departure.timezoneOffset }}</div>
              <div class="field-report-button mat-ripple text-button text-base"
                (click)="onFieldReportClick(flightInfo.response.departure.station || '')">Field Report
              </div>
            </div>
          </div>
        </div>
        <div class="col right-detail-col">
          <div class="col">
            <div class="arpt-container">
              <div class="text-center text-base">{{ flightInfo.response.arrival.icao }}/{{
                flightInfo.response.arrival.station
                }}</div>
              <div class="text-center text-sm opacity-6">{{ flightInfo.response.arrival.name }}</div>
            </div>
            <div class="text-center text-base mt-6">
              <span>{{
                flightInfo.response.arrival.depOrArrTimeLocal?.toFormat('HH:mm') }}L </span>
              <span class="opacity-6">({{
                flightInfo.response.arrival.depOrArrTimeUtc?.toFormat('HH:mm') }}Z)</span>
            </div>
          </div>
          <div class="details-container">
            <mat-divider class="ml-8 width-100"></mat-divider>
            <div class="details-grid">
              <div class="label-3 pr-1">Elev</div>
              <div class="text-base pl-8">{{ flightInfo.response.arrival.elevation }}</div>
              <div class="label-3 pr-1">UTC</div>
              <div class="text-base pl-8">{{ flightInfo.response.arrival.timezoneOffset }}</div>
              <div class="field-report-button mat-ripple text-button text-base"
                (click)="onFieldReportClick(flightInfo.response.arrival.station || '')">Field Report
              </div>
            </div>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="text-center text-base"><span class="label-2">Time Change</span> {{
        flightInfo.response.timeChange }}
      </div>
    </div>

    <div class="caution-msg caution-color text-xs text-center">Elevation data is obtained from Sabre and should only be
      used for
      general awareness.
    </div>
    }
    <div class="data-status">
      <app-data-status [isLoading]="flightInfo.isLoading" [timestamp]="flightInfo.response?.timestamp"
        (refresh)="refreshFlightInfo()"></app-data-status>
    </div>
    <mat-progress-bar *ngIf="flightInfo.isLoading" class="progress-bar-bottom" color="accent"
      mode="indeterminate"></mat-progress-bar>
    }
    }
  </ng-template>
</mat-expansion-panel>